// Import models
const Product = require('./Product');
const InsertSet = require('./InsertSet');
const Card = require('./Card');
const InventoryItem = require('./InventoryItem');
const WishlistItem = require('./WishlistItem');
const CardForTrade = require('./CardForTrade');
const Stats = require('./Stats');

// Export models for CommonJS compatibility (Node.js backend)
module.exports = {
  Product,
  InsertSet,
  Card,
  InventoryItem,
  WishlistItem,
  CardForTrade,
  Stats
};

// Support dual module system (ES modules and CommonJS)
if (typeof module !== 'undefined' && module.exports) {
  // Add named exports for ES modules compatibility
  Object.defineProperty(module.exports, '__esModule', { value: true });
}